import * as React from 'react';
import { Edit } from 'react-admin';
import { WorkerTitle, WorkerForm } from './commons';
import { transformRecord } from './utils';

const WorkerEdit = () => {
    return (
        <Edit title={<WorkerTitle />} transform={transformRecord} mutationMode="pessimistic" redirect="list">
            <WorkerForm />
        </Edit >
    )
}

export default WorkerEdit;
